import { render, staticRenderFns } from "./signPrintItem.vue?vue&type=template&id=5e16440c&"
import script from "./signPrintItem.vue?vue&type=script&lang=js&"
export * from "./signPrintItem.vue?vue&type=script&lang=js&"
import style0 from "./signPrintItem.vue?vue&type=style&index=0&id=5e16440c&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports